import { render, staticRenderFns } from "./defect-serverity-item.vue?vue&type=template&id=766e3754&scoped=true&"
import script from "./defect-serverity-item.vue?vue&type=script&lang=js&"
export * from "./defect-serverity-item.vue?vue&type=script&lang=js&"
import style0 from "./defect-serverity-item.vue?vue&type=style&index=0&id=766e3754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766e3754",
  null
  
)

export default component.exports